class ContentTabs extends HTMLElement {
    constructor() {
        super(),
            this.buttons = this.querySelectorAll(".content-tab-button"),
            this.tabs = this.querySelectorAll(".content-tab"),
            this.tabsContainer = this.querySelector(".content-tabs__tabs"),
            this.activeButton = this.querySelector(".content-tab-button--active"),
            this.activeTab = this.querySelector(".content-tab--active"),
            this.isMovingAnimation = "moving" === this.dataset.animation,
            this.isMovingAnimation && (this.activeBg = this.querySelector(".content-tab-buttom__active-bg"),
                this.handleActiveBg(),
                this.activeBg.style.transitionDuration = "0.4s"),
            this.setHeight(),
            this.buttons.forEach(t => {
                t.addEventListener("click", this.handleClick.bind(this))
            }
            ),
            window.addEventListener("resize", () => {
                this.setHeight(),
                    this.isMovingAnimation && this.handleActiveBg()
            }
            )
    }
    handleClick(t) {
        this.activeButton = t.currentTarget,
            this.buttons.forEach(t => {
                t.classList.remove("content-tab-button--active")
            }
            ),
            this.activeButton.classList.add("content-tab-button--active"),
            this.tabs.forEach(t => {
                t.classList.remove("content-tab--active"),
                    t.dataset.index === this.activeButton.dataset.index && (this.activeTab = t)
            }
            ),
            this.activeTab.classList.add("content-tab--active"),
            this.setHeight(),
            this.isMovingAnimation && this.handleActiveBg()
    }
    setHeight() {
        this.activeTab && (this.tabsContainer.style.height = this.activeTab.clientHeight + "px")
    }
    handleActiveBg() {
        this.activeBg.style.width = this.activeButton.getBoundingClientRect().width + "px",
            this.activeBg.style.height = this.activeButton.getBoundingClientRect().height + "px",
            this.activeBg.style.top = this.activeButton.offsetTop + "px",
            this.activeBg.style.left = this.activeButton.offsetLeft + "px"
    }
}
customElements.define("content-tabs", ContentTabs);